export default "/images/70051a09f0c0e90c879e25b5c63233ad.avif";